import Focus from '../../types/enums/focus';
import User from '../../classes/user';
import goToChannel from '../../actions/channels/goToChannel';
import { clearModal } from '../slices/modal.slice';
import { closeFloatingMenu } from './floatingMenu.thunk';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { reset } from '../slices/media.slice';
import { clearFocus, setFocus } from '../slices/focus.slice';
import {
  IChannelsState,
  IMagicRemoteState,
  IRouteState,
  IUserState,
} from '../../types/interfaces/states';
import {
  popRoute as popRouteAction,
  pushRoute as pushRouteAction,
  initialState,
} from '../slices/router.slice';

const popRoute = createAsyncThunk('pop/route', (data, thunk) => {
  try {
    const { channels, magicRemote, router, user } = thunk.getState() as {
      channels: IChannelsState;
      magicRemote: IMagicRemoteState;
      router: IRouteState;
      user: IUserState;
    };

    // Clear page states
    thunk.dispatch(reset());
    thunk.dispatch(clearModal());
    thunk.dispatch(closeFloatingMenu());

    // Pop stacked route
    if (router.route.stack.length) {
      thunk.dispatch(clearFocus());
      thunk.dispatch(popRouteAction());
    }
    // Set initial Page as default returning Page
    else if (router.route.Page !== initialState.route.Page) {
      thunk.dispatch(
        pushRouteAction({
          route: {
            Page: initialState.route.Page,
            overwrite: true,
          },
        })
      );
      if (!magicRemote.enabled) {
        thunk.dispatch(setFocus(Focus.MENU));
      }
    }
    // If already on initial Page, go to Zapper
    else {
      const channel =
        channels.channelsData?.find(
          (item) => item.code === User.getPlan(user?.planId)?.defaultChannel
        ) || channels?.currentChannel;
      goToChannel({ channel });
    }
  } catch (error) {
    thunk.rejectWithValue(error);
  }
});

const pushRoute = createAsyncThunk(
  'push/route',
  (
    data: {
      params?: {
        current?: {
          [key: string]: unknown;
        };
        stack?: {
          [key: string]: unknown;
        };
        push?: boolean;
      };
      route: {
        push?: boolean;
        overwrite?: boolean;
        Page: () => JSX.Element;
      };
    },
    thunk
  ) => {
    try {
      thunk.dispatch(reset());
      thunk.dispatch(clearModal());
      thunk.dispatch(closeFloatingMenu());
      thunk.dispatch(pushRouteAction(data));
    } catch (error) {
      thunk.rejectWithValue(error);
    }
  }
);

export { popRoute, pushRoute };
